import { Board, BoardBackend } from '../board/board';
import { Workspace, WorkspaceComboBackend } from './workspace';

function initInPlace(workspace: Partial<Workspace>): Workspace {
  return workspace as Workspace;
}

function isCreator({
  workspace,
  board,
}: {
  workspace: Workspace | WorkspaceComboBackend;
  board: Board | BoardBackend;
}) {
  return workspace.createdById === board.userBoardConfig!.userId;
}

export const WorkspaceFuncs = { isCreator, initInPlace };
